<template>
  <div id="app" ref="rootelement" class="vibevision-bootstrap">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
        <a class="navbar-brand" href="#">Logo tähän</a>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item" v-if="!atLoadingStep && !atSendingStep">
                <a class="nav-link" v-on:click="toggleLanguageMenu">Language</a>
              </li>
            </ul>
          </div>
      </nav>

      <div v-if=languageMenuVisible id="languageMenu">
        <div class="bg-dark p-4 d-flex justify-content-end">
          <ul>
            <li><a class="text-light" v-on:click="setLanguage('en')">English</a></li>
            <li><a class="text-light" v-on:click="setLanguage('fi')">Finnish</a></li>
            <li><a class="text-light" v-on:click="setLanguage('ru')">Russia</a></li>
            <li><a class="text-light" v-on:click="setLanguage('de')">German</a></li>
            <li><a class="text-light" v-on:click="setLanguage('tr')">Turkish</a></li>
          </ul>
        </div>
      </div>
    </div>

    <LoadingStep v-if=atLoadingStep msg="Displaying loading step"/>
    <EmotionStep v-if=atEmotionStep msg="Displaying emotion step"/>
    <DetailsStep v-if=atDetailsStep msg="Displaying details step"/>
    <SendingStep v-if=atSendingStep msg="Displaying sending step"/>
    <EndStep v-if=atEndStep msg="Displaying end step"/>
  </div>
</template>

<script>
import LoadingStep from './components/steps/Loading.vue'
import EmotionStep from './components/steps/Emotion.vue'
import DetailsStep from './components/steps/Details.vue'
import SendingStep from './components/steps/Sending.vue'
import EndStep from './components/steps/End.vue'

export default {
  name: 'App',
  components: {
    LoadingStep,
    EmotionStep,
    DetailsStep,
    SendingStep,
    EndStep
  },

  data: () => ({
    languageMenuVisible: false
  }),

  created() {
    window.addEventListener('resize', this.handleResize)
  },
  mounted() {
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },

  computed: {
    currentStep () {
      return this.$store.getters.currentStep
    },
    atLoadingStep () {
      return this.$store.getters.atLoadingStep
    },
    atEmotionStep () {
      return this.$store.getters.atEmotionStep
    },
    atDetailsStep () {
      return this.$store.getters.atDetailsStep
    },
    atSendingStep () {
      return this.$store.getters.atSendingStep
    },
    atEndStep () {
      return this.$store.getters.atEndStep
    },

    currentLanguage () {
      return this.$store.getters.language
    }
  },
  methods: {
    handleResize() {
      // TODO Fetch correct width/height for canvas with fallbacks
      this.$store.dispatch('setWindowSize', {
        width: window.innerWidth,
        height: window.innerHeight
      })
    },
    toggleLanguageMenu: function() {
      this.languageMenuVisible = !this.languageMenuVisible
    },
    showLanguageMenu: function() {
      this.languageMenuVisible = true
    },
    hideLanguageMenu: function() {
      this.languageMenuVisible = false
    },
    setLanguage: function(language) {
      this.$store.dispatch('setLanguage', {language: language})
      this.hideLanguageMenu()
    }
  }
}
</script>

<style lang="scss">
.vibevision-bootstrap {

}
</style>
